import { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import $ from "jquery";
import api from "../../utils/axios";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import { showLoader, hideLoader, showAlert, isEmpty, isSingleSelect, showContaimerLoader, removeChar, showDate, showDBDate, hasPermission } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
const dropDownlist = [
  { label: "Branch", key: "branch", optionList: "branchList" },
  { label: "PO Type", key: "pomtype", optionList: "pomtypeList" },
  { label: " PO Raised By", key: "potype", optionList: "potypeList" },
  { label: "Vessel", key: "POvessel", optionList: "vessleList" },
  { label: "Vendor", key: "vendor", optionList: "vendorList" },
  { label: "Currency", key: "poCurrency", optionList: "currencyList" },
];
const poItem = {
  cateogry: "",
  candidates: [],
  candidateID: "",
  description: "",
  quantity: "",
  unit: "",
  rate: "",
  gstValue: "",
  gstAmount: "",
  totalRate: 0.0,
  cateogryErr: false,
  candidatesErr: false,
  descriptionErr: false,
  quantityErr: false,
  unitErr: false,
  rateErr: false,
};
const module = "purchaseorder";
const modulePath = "/purchaseorder";
const moduleID = 16;
class Form extends Component {
  constructor(props) {
    super(props);
    const editID = this.props.location.state?.editID ?? "";
    this.state = {
      editID,
      postdata: {
        branch: "",
        pomtype: { label: "Vessel", value: "Vessel" },
        potype: "",
        POvessel: "",
        vendor: "",
        po_date: new Date(),
        vendor_ref: "",
        poCurrency: "",
        poItem: [poItem],
        poItemError: "",
        subTotal: 0,
        totalTaxAmount: 0,
        LessDiscount: "",
        insurance_amount: "",
        del_charges: "",
        other_amount: "",
        grand_total: 0,
        poNote: "",
      },
      branchList: [],
      pomtypeList: [
        { label: "Vessel", value: "Vessel" },
        { label: "Office Expenses", value: "Office Expenses" },
      ],
      potypeList: [
        { label: "Nautilus", value: "Nautilus" },
        { label: "Owners", value: "Ownerss" },
      ],
      vessleList: [],
      vendorList: [],
      currencyList: [
        { label: "INR", value: "INR" },
        { label: "USD", value: "USD" },
        { label: "EUR", value: "EUR" },
        { label: "AED", value: "AED" },
      ],
      categoryList: [],
      detaildata: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
      const params = {
        params: "",
        url: `${module}/detail/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
    }
    this.loadDropdown();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
  }
  loadDropdown() {
    api
      .get("branch/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ branchList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("vessel/alldropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          let finalVessel = [];
          result.forEach((vessel) => {
            if (vessel.vesselCode !== "" && vessel.vesselCode !== null) {
              finalVessel.push(vessel);
            }
          });
          this.setState({ vessleList: finalVessel });
        }
      })
      .catch((err) => {
        console.error(err);
      });

    api
      .get("povendor/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          this.setState({ vendorList: result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("pocategory/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          this.setState({ categoryList: result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }), () => {
      const poItem__ = this.state.postdata.poItem;
      let subTotal = 0;
      let totalTaxAmount_ = 0;
      if (poItem__.length > 0) {
        poItem__.map((item) => {
          subTotal += parseFloat(item.totalRate);
          totalTaxAmount_ += (item.gstAmount !== "" && parseFloat(item.gstAmount)) > 0 ? parseFloat(item.gstAmount) : 0;
          return "";
        });
      }
      const postdata = this.state.postdata;
      const LessDiscount = parseFloat(postdata.LessDiscount) > 0 ? postdata.LessDiscount : 0;
      const insurance_amount = parseFloat(postdata.insurance_amount) > 0 ? postdata.insurance_amount : 0;
      const del_charges = parseFloat(postdata.del_charges) > 0 ? postdata.del_charges : 0;
      const other_amount = parseFloat(postdata.other_amount) > 0 ? postdata.other_amount : 0;
      const grandTotal = parseFloat(subTotal) + parseFloat(insurance_amount) + parseFloat(del_charges) + parseFloat(other_amount) - parseFloat(LessDiscount);

      this.setState(update(this.state, { postdata: { subTotal: { $set: subTotal }, grand_total: { $set: grandTotal }, totalTaxAmount: { $set: totalTaxAmount_ } } }));
    });
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    const postData = this.state.postdata;
    const poItem____ = postData.poItem;
    let finalItem = [];
    if (poItem____.length > 0) {
      poItem____.map((item) => {
        finalItem.push({
          cateogry: item.cateogry?.value || "",
          candidates: item.candidates,
          candidateID: item.candidateID,
          description: item.description,
          quantity: item.quantity,
          unit: item.unit?.value || "",
          rate: item.rate,
          gstValue: item.gstValue,
          gstAmount: item.gstAmount,
          totalRate: item.totalRate,
        });
        return "";
      });
    }
    const subTotal = postData.subTotal;
    const totalTaxAmount = postData.totalTaxAmount;
    const postObject = {
      branch: postData.branch?.value || "",
      potype: postData.potype?.value || "",
      pomtype: postData.pomtype?.value || "",
      POvessel: postData.POvessel?.value || "",
      vendor: postData.vendor?.value || "",
      po_date: showDBDate(postData.po_date),
      vendor_ref: postData.vendor_ref || "",
      poCurrency: postData.poCurrency?.value || "",
      finalItem: JSON.stringify(finalItem),
      subTotal: parseFloat(subTotal) - parseFloat(totalTaxAmount),
      gst_amount: totalTaxAmount,
      del_charges: postData?.del_charges || 0,
      insurance_amount: postData?.insurance_amount || 0,
      other_amount: postData?.other_amount || 0,
      lessDiscount: postData?.LessDiscount || 0,
      grand_total: postData?.grand_total || 0,
      poNote: postData.poNote,
    };

    let post_url = `${module}/createPO`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid  mx-3">
                  <div className="container-fluid">
                    <div className="page-header">
                      <h1 className="page-title">Create Purchase Order</h1>
                    </div>

                    {this.state.pageloading ? (
                      showContaimerLoader()
                    ) : (
                      <PostForm
                        {...this.props}
                        fields={this.state.postdata}
                        branchList={this.state.branchList}
                        pomtypeList={this.state.pomtypeList}
                        potypeList={this.state.potypeList}
                        vessleList={this.state.vessleList}
                        vendorList={this.state.vendorList}
                        currencyList={this.state.currencyList}
                        categoryList={this.state.categoryList}
                        onChange={this.fieldChange}
                        onValid={this.handleSubmit}
                        editID={this.state.editID}
                        error_msg={this.state.error_msg}
                        onInvalid={() => {
                          console.log("Form invalid!");
                          setTimeout(function () {
                            if ($("#modulefrm .error").length > 0) {
                              $("html, body").animate(
                                {
                                  scrollTop: $(document).find("#modulefrm .error:first").offset().top - 100,
                                },
                                500,
                              );
                            }
                          }, 500);
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

const isPOvesselSelect = (value, pomtype) => {
  // validation only for Vessel
  if (pomtype?.value !== "Vessel") {
    return null;
  }

  // Vessel selected but no value
  if (!value || Object.keys(value).length === 0) {
    return "This field is required.";
  }

  return null;
};

function validationConfig(props) {
  const { branch, pomtype, potype, POvessel, vendor, poCurrency, vendor_ref, poItemError } = props.fields;

  return {
    fields: ["branch", "pomtype", "potype", "POvessel", "vendor", "poCurrency", "vendor_ref", "poItemError"],
    validations: {
      branch: [[isSingleSelect, branch]],
      pomtype: [[isSingleSelect, pomtype]],
      potype: [[isSingleSelect, potype]],
      POvessel: [[isPOvesselSelect, POvessel, pomtype]],
      vendor: [[isSingleSelect, vendor]],
      poCurrency: [[isSingleSelect, poCurrency]],
      vendor_ref: [[isEmpty, vendor_ref]],
      poItem: [[isEmpty, poItemError]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slectedPDF: "",
    };
  }
  goBack() {
    this.props.history.push(modulePath);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handlecheckedChange(name, e) {
    this.props.onChange(name, e.target.checked);
  }
  newItem() {
    const poItem_ = [...this.props.fields.poItem];
    poItem_.push({
      cateogry: "",
      candidates: [],
      candidateID: "",
      description: "",
      quantity: "",
      unit: "",
      rate: "",
      gstValue: "",
      gstAmount: "",
      totalRate: 0.0,
      cateogryErr: false,
      candidatesErr: false,
      descriptionErr: false,
      quantityErr: false,
      unitErr: false,
      rateErr: false,
    });
    this.props.onChange("poItem", poItem_);
  }

  checkCandiate = async (updindex, e) => {
    if (e.key === "Enter") {
      const value = e.target.value;
      try {
        const serverResponse = await api.get(`${module}/getNemoDetails?nemoID=${value}`);
        const status = serverResponse?.data?.success;
        if (status === true) {
          let result = serverResponse?.data?.result;
          result.candidateID = value;
          let updatecandidate = this.props.fields.poItem[updindex].candidates;
          const exists = updatecandidate.some((item) => item.candidateID === value);
          if (!exists) {
            updatecandidate.push(result);
          }

          this.updateitemValue(updindex, "candidates", updatecandidate);
        }
      } catch (err) {
        const errMsg = err?.response?.data?.message || err?.message;
        showAlert("Error", errMsg, "error", "No");
        console.log(err, "errerrerr");
      }
    }
  };

  handleSelectChangeItem(index, filedName, value) {
    this.updateitemValue(index, filedName, value);
  }
  handleTextChangeItem(index, filedName, e) {
    let value = e.target.value;
    if (!/^\d*\.?\d*$/.test(value) && ["quantity", "gstValue", "rate", "candidateID"].indexOf(filedName)>=0) {
      return;
    }
    this.updateitemValue(index, filedName, value);
  }

  updateitemValue(updindex, filedName, value) {
    let poItem_ = this.props.fields.poItem;
    let error = 0;
    const updatepoItem = poItem_.map((item, index) => {
      if (index === updindex) {
        if (filedName === "candidates") {
          item.candidateID = "";
        }
        item[filedName] = value;
        const quantity = parseFloat(item.quantity);
        const rate = parseFloat(item.rate);
        const gstValue = item.gstValue;
        let totalRate = parseFloat(quantity) > 0 && parseFloat(rate) > 0 ? parseFloat(rate * quantity).toFixed(2) : 0.0;
        if (parseFloat(gstValue) > 0) {
          const gstAmount = parseFloat(parseFloat(totalRate) * (parseFloat(gstValue) / 100)).toFixed(2);
          item.gstAmount = gstAmount;
          totalRate = parseFloat(parseFloat(totalRate) + parseFloat(gstAmount)).toFixed(2);
        }
        item.totalRate = totalRate;
      }
      if(this.props.fields.pomtype?.value==='Office Expenses') {
        item.descriptionErr = item.description === "" ? (++error, true) : false;
        console.log(item.descriptionErr, 'descriptionErrdescriptionErrdescriptionErr')
      }else {
        item.cateogryErr = item.cateogry === "" ? (++error, true) : false;
        item.candidatesErr = item.candidates.length === 0 ? (++error, true) : false;
      }
      
      item.quantityErr = item.quantity === "" ? (++error, true) : false;
      item.unitErr = item.unit === "" ? (++error, true) : false;
      item.rateErr = item.rate === "" ? (++error, true) : false;
      return item;
    });
    this.props.onChange("poItem", updatepoItem);
    setTimeout(() => {
      if (error === 0) {
        this.props.onChange("poItemError", "No");
      } else {
        this.props.onChange("poItemError", "");
      }
    }, 500);
  }

  validatePOItem = (value, onChange) => {
    let showError = 0;
    const poItem___ = this.props.fields.poItem;

    if (poItem___.length > 0) {
      let finalValue = poItem___.map((item) => {
        if(this.props.fields.pomtype?.value==='Office Expenses') {
        item.descriptionErr = item.description === "" ? (++showError, true) : false;
        console.log(item.descriptionErr, 'descriptionErrdescriptionErrdescriptionErr')
      }else {
        item.cateogryErr = item.cateogry === "" ? (++showError, true) : false;
        item.candidatesErr = item.candidates.length === 0 ? (++showError, true) : false;
      }

        
        item.quantityErr = item.quantity === "" ? (++showError, true) : false;
        item.unitErr = item.unit === "" ? (++showError, true) : false;
        item.rateErr = item.rate === "" ? (++showError, true) : false;

        return item;
      });
      this.props.onChange("poItem", finalValue);
      setTimeout(() => {
        if (showError === 0) {
          this.props.onChange("poItemError", "No");
        } else {
          this.props.onChange("poItemError", "");
        }
      }, 500);
    }
  };
  removeItem(index) {
    let existpoItem___ = this.props.fields.poItem;
    existpoItem___.splice(index, 1);
    this.props.onChange("poItem", existpoItem___);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errorMsg = {};
    if ($validation.branch.error.reason !== undefined) {
      errorMsg.branch = $validation.branch.show && <span className="error">{$validation.branch.error.reason}</span>;
    }
    if ($validation.pomtype.error.reason !== undefined) {
      errorMsg.pomtype = $validation.pomtype.show && <span className="error">{$validation.pomtype.error.reason}</span>;
    }
    if ($validation.potype.error.reason !== undefined) {
      errorMsg.potype = $validation.potype.show && <span className="error">{$validation.potype.error.reason}</span>;
    }
    if ($validation.POvessel.error.reason !== undefined) {
      errorMsg.POvessel = $validation.POvessel.show && <span className="error">{$validation.POvessel.error.reason}</span>;
    }
    if ($validation.vendor.error.reason !== undefined) {
      errorMsg.vendor = $validation.vendor.show && <span className="error">{$validation.vendor.error.reason}</span>;
    }
    if ($validation.poCurrency.error.reason !== undefined) {
      errorMsg.poCurrency = $validation.poCurrency.show && <span className="error">{$validation.poCurrency.error.reason}</span>;
    }
    if ($validation.vendor_ref.error.reason !== undefined) {
      errorMsg.vendor_ref = $validation.vendor_ref.show && <span className="error">{$validation.vendor_ref.error.reason}</span>;
    }
    console.log($validation, '$validation$validation')

    return (
      <div id="modulefrm">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">PO Information</h3>
              </div>

              <div className="card-body">
                <div className="row g-3">
                  {dropDownlist.map((item, index) => {
                    let showlist = true;
                    if (item.key === "POvessel") {
                      showlist = fields.pomtype?.value === "Office Expenses" ? false : true;
                    }
                    if (showlist) {
                      return (
                        <div className="col-md-3" key={index}>
                          <label className="form-label">{item.label}</label>
                          <Select
                            value={fields[`${item.key}`]}
                            onChange={this.handleSelectChange.bind(this, item.key)}
                            placeholder={`Select ${item.label}`}
                            isClearable={item.key !== "pomtype" ? true : false}
                            options={this.props[`${item.optionList}`]}
                          />
                          {errorMsg[item.key]}
                        </div>
                      );
                    }
                    return "";
                  })}
                  <div className="col-md-3">
                    <label className="form-label">
                      PO Date<span className="lbl-error">*</span>
                    </label>
                    <input
                      type="text"
                      readOnly={true}
                      className="form-control"
                      placeholder="PO Date"
                      name="rankOrder"
                      value={showDate(fields.po_date)}
                      {...$field("po_date", (e) => onChange("po_date", e.target.value))}
                    />
                    {/* errMsgrankOrder */}
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">
                      Vendor Ref.<span className="lbl-error">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Vendor Ref."
                      name="rankOrder"
                      value={fields.vendor_ref}
                      {...$field("vendor_ref", (e) => onChange("vendor_ref", e.target.value))}
                    />
                    {errorMsg.vendor_ref}
                  </div>
                </div>

                <div className="text-end mt-4">
                  <button className="btn btn-primary" onClick={this.newItem.bind(this)}>
                    <i className="fe fe-plus"></i> Add Item
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">PO Items</h3>
              </div>

              <div className="card-body p-0">
                <input type="hidden" name="poItemError" value={fields.poItemError} />
                <div>
                  <table className="table table-bordered text-nowrap mb-0">
                    <thead className="bg-primary text-white">
                      <tr>
                        <th className="text-white" style={{ width: "50px" }}>
                          S.No
                        </th>
                        {fields.pomtype?.value === "Vessel" && (
                          <>
                            <th className="text-white" style={{ width: "230px" }}>
                              Category
                            </th>
                            <th className="text-white" style={{ width: "120px" }}>
                              Nemo ID
                            </th>
                          </>
                        )}
                        <th className="text-white">Description</th>
                        <th className="text-white" style={{ width: "80px" }}>
                          Qty
                        </th>
                        <th className="text-white" style={{ width: "150px" }}>
                          Unit
                        </th>
                        <th className="text-white" style={{ width: "100px" }}>
                          Rate
                        </th>
                        <th className="text-white" style={{ width: "80px" }}>
                          Tax (%)
                        </th>
                        <th className="text-white" style={{ width: "100px" }}>
                          Tax Amount
                        </th>
                        <th className="text-white" style={{ width: "100px" }}>
                          Total
                        </th>
                        <th className="text-white" style={{ width: "80px" }}>
                          Action
                        </th>
                      </tr>
                    </thead>

                    <tbody className="po-mitem">
                      {fields.poItem.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{parseInt(index) + 1}</td>
                            {fields.pomtype?.value === "Vessel" && (
                              <>
                                <td>
                                  <Select
                                    value={item.cateogry}
                                    onChange={this.handleSelectChangeItem.bind(this, index, "cateogry")}
                                    placeholder={`Select Category`}
                                    isClearable={true}
                                    className={`${item.cateogryErr ? "select-frm-error" : ""}`}
                                    options={this.props.categoryList}
                                  />
                                </td>

                                <td>
                                  <input
                                    className={`form-control ${item.candidatesErr ? "sp-input sp-validation-error" : ""}`}
                                    placeholder="Candidate ID"
                                    style={{ width: "120px" }}
                                    onKeyDown={this.checkCandiate.bind(this, index)}
                                    onChange={this.handleTextChangeItem.bind(this, index, "candidateID")}
                                    value={item.candidateID}
                                  />
                                </td>
                              </>
                            )}

                            <td>
                              {fields.pomtype?.value === "Vessel" ? (
                                item.candidates.length > 0 && (
                                  <ul className="list-group">
                                    {item.candidates.map((citem, cindex) => {
                                      return (
                                        <li className="listunorder" style={{ padding: "0" }} key={cindex}>
                                          {citem.candidateID} <br /> {citem.name} <br /> {citem.c_rank}
                                        </li>
                                      );
                                    })}
                                  </ul>
                                )
                              ) : (
                                <input
                                  className={`form-control ${item.descriptionErr ? "sp-input sp-validation-error" : ""}`}
                                  style={{ width: "400px" }}
                                  placeholder="Description"
                                  onChange={this.handleTextChangeItem.bind(this, index, "description")}
                                  value={item.description}
                                />
                              )}
                            </td>

                            <td>
                              <input
                                className={`form-control ${item.quantityErr ? "sp-input sp-validation-error" : ""}`}
                                style={{ width: "80px" }}
                                placeholder="QTY"
                                onChange={this.handleTextChangeItem.bind(this, index, "quantity")}
                                value={item.quantity}
                              />
                            </td>

                            <td style={{ width: "150px" }} className="item-unit">
                              <Select
                                value={item.unit}
                                onChange={this.handleSelectChangeItem.bind(this, index, "unit")}
                                placeholder={`Unit`}
                                isClearable={true}
                                className={`${item.unitErr ? "select-frm-error" : ""}`}
                                options={[
                                  { label: "Nos", value: "Nos" },
                                  { label: "Doz", value: "Doz" },
                                  { label: "Set", value: "Set" },
                                  { label: "Pcs", value: "Pcs" },
                                ]}
                              />
                            </td>

                            <td>
                              <input
                                className={`form-control ${item.rateErr ? "sp-input sp-validation-error" : ""}`}
                                style={{ width: "100px" }}
                                onChange={this.handleTextChangeItem.bind(this, index, "rate")}
                                value={item.rate}
                              />
                            </td>

                            <td>
                              <input className="form-control" style={{ width: "70px" }} onChange={this.handleTextChangeItem.bind(this, index, "gstValue")} value={item.gstValue} />
                            </td>

                            <td>
                              {fields.poCurrency?.value || ""} {parseFloat(item.gstAmount) > 0 ? item.gstAmount : 0.0}
                            </td>
                            <td>
                              {fields.poCurrency?.value || ""} {parseFloat(item.totalRate) > 0 ? item.totalRate : 0.0}
                            </td>

                            <td className="text-center">{fields.poItem.length > 1 && <i className="fe fe-trash pointer text-danger" onClick={this.removeItem.bind(this, index)}></i>}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-8">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Note</h3>
              </div>

              <div className="card-body">
                <textarea className="form-control" rows="4" placeholder="Enter note here..." value={fields.poNote} {...$field("poNote", (e) => onChange("poNote", e.target.value))}></textarea>
              </div>
            </div>
          </div>

          <div className="col-xl-4">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Amount Summary</h3>
              </div>

              <div className="card-body">
                <div className="d-flex justify-content-between mb-3">
                  <span>Sub Total</span>
                  <span>
                    {fields.poCurrency?.value || ""} {parseFloat(fields.subTotal) > 0 ? parseFloat(fields.subTotal).toFixed(2) : 0.0}
                  </span>
                </div>

                <div className="d-flex justify-content-between mb-3">
                  <span>Less Discount (-)</span>
                  <input className="form-control w-50" value={fields.LessDiscount} {...$field("LessDiscount", (e) => onChange("LessDiscount", e.target.value))} />
                </div>

                <div className="d-flex justify-content-between mb-3">
                  <span>Add Insurance</span>
                  <input className="form-control w-50" value={fields.insurance_amount} {...$field("insurance_amount", (e) => onChange("insurance_amount", e.target.value))} />
                </div>

                <div className="d-flex justify-content-between mb-3">
                  <span>Add Delivery Charges</span>
                  <input className="form-control w-50" value={fields.del_charges} {...$field("del_charges", (e) => onChange("del_charges", e.target.value))} />
                </div>

                <div className="d-flex justify-content-between mb-3">
                  <span>Other</span>
                  <input className="form-control w-50" value={fields.other_amount} {...$field("other_amount", (e) => onChange("other_amount", e.target.value))} />
                </div>

                <hr />

                <div className="d-flex justify-content-between fs-18 fw-bold">
                  <span>Total Amount</span>
                  <span>
                    {fields.poCurrency?.value || ""} {parseFloat(fields.grand_total) > 0 ? parseFloat(fields.grand_total).toFixed("2") : 0.0}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div className="btn-group me-2 sw-btn-group-extra submit_frm" role="group">
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                  this.validatePOItem(this);
                }}
              >
                {this.props.editID !== "" ? "Update" : "Create PO"}
              </button>

              <button className="btn btn-secondary" onClick={this.goBack.bind(this)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
